
import { defineComponent, ref, PropType } from 'vue'
import { useInvoicesModule } from '@/modules/invoices'
import QForm from 'quasar/src/components/form/QForm.js';import useQuasar from 'quasar/src/composables/use-quasar.js';
import { useFormModule } from '@/modules/_shared/forms'
import { useSessionModule } from '@/modules/session'

export default defineComponent({
    name: 'invoices-revoke-invoice-form',
    props: {
        invoiceId: {
            type: String,
            required: true
        },
        updateCallback: {
            type: Function as PropType<() => void>,
            required: true
        }
    },
    setup (props) {
        const $q = useQuasar()
        const { submitForm, createOnSuccess } = useFormModule()
        const { revokeInvoice, getInvoices } = useInvoicesModule()
        const { isOperatorInvoicingManager } = useSessionModule()

        const form = ref<QForm>()
        const revokeInvoiceRequest = async () => revokeInvoice(props.invoiceId)

        function showConfirmRevokeDialog () {
            $q.dialog({
                title: 'Revoking invoice',
                message: 'Are you sure you want proceed this action?',
                cancel: true,
                persistent: true
            }).onOk(() => {
                submitForm(
                    form.value,
                    revokeInvoiceRequest,
                    createOnSuccess('Invoice has been revoked')
                ).then(() => {
                    props.updateCallback()
                    getInvoices()
                })
            })
        }

        return {
            showConfirmRevokeDialog,
            form,
            isInvoicingManager: isOperatorInvoicingManager
        }
    }
})
